<template>
  <div class="recommendations" :class="{ 'recommendations--compact': isCompact }">
    <ProductRecommendationsProvider
      :pageType="DY_PAGE_TYPES.homepage"
      :selectorName="DY_API_CAMPAIGN_SELECTOR_NAMES.homeProductRecommendations"
      #default="recomendationData"
    >
      <ProductRecommendationsCards
        v-bind="recomendationData"
        :hasTitle="hasTitle"
        :maxItems="[
          [700, 3],
          [0, 2],
        ]"
        :isQuickViewEnabled="isQuickViewEnabled"
        :isQuickAddEnabled="isQuickAddEnabled"
        :target="target"
      />
    </ProductRecommendationsProvider>
  </div>
</template>

<script>
import { DY_API_CAMPAIGN_SELECTOR_NAMES } from '@/config/constants'
import ProductRecommendationsProvider from '@/components/_shared/ProductRecommendations/ProductRecommendationsProvider.vue'
import ProductRecommendationsCards from '@/components/_shared/ProductRecommendations/ProductRecommendationsCards.vue'
import { DY_PAGE_TYPES } from '@/services/external-communication/dynamic-yield/dy-events'

export default {
  name: 'Recommendations',
  components: {
    ProductRecommendationsProvider,
    ProductRecommendationsCards,
  },

  props: {
    hasTitle: {
      type: Boolean,
      default: true,
    },
    isCompact: {
      type: Boolean,
      default: false,
    },
    isQuickViewEnabled: {
      type: Boolean,
      default: true,
    },
    isQuickAddEnabled: {
      type: Boolean,
      default: true,
    },
    target: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      DY_API_CAMPAIGN_SELECTOR_NAMES,
      DY_PAGE_TYPES,
    }
  },
}
</script>

<style scoped lang="scss">
$max-card-width: 525px;
$max-card-width-compact: 300px;
$max-card-height-compact: 320px;

.recommendations {
  /deep/ .product-recommendations-cards {
    padding: 0;

    .cards {
      justify-content: left;
    }

    .card {
      margin: 0 10px 0 0;
      max-width: $max-card-width;
    }

    &__products {
      padding: 0;
    }

    @media ($desktop-huge-up) {
      &__products {
        max-width: unset;
      }
    }
  }

  &--compact {
    overflow: hidden;

    /deep/ .product-recommendations-cards {
      .card {
        max-width: $max-card-width-compact;
      }
    }

    /deep/ .card-visual-box__inner,
    /deep/ .card-visual-box__image {
      max-height: $max-card-height-compact;
    }
  }

  /deep/ .product-recommendations-cards__title {
    font-family: $font-family-helvetica-now;
    font-weight: 700;
    text-align: center;
    color: $color-black;
    letter-spacing: -0.02em;
    text-transform: capitalize;
    margin: 24px 0 33px;
    font-size: 24px;
    line-height: 1.2;

    @media ($mobile-up) {
      font-size: 26px;
      margin: 24px 0 20px;
    }

    @media ($tablet-up) {
      font-size: 24px;
      margin: 36px 0 16px;
    }

    @media ($tablet-large-up) {
      font-size: 36px;
      margin: 88px 0 48px;
    }

    @media ($desktop-huge-up) {
      font-size: 52px;
    }
  }

  /deep/ .card__bottom-box {
    @media ($tablet-up) {
      min-height: 245px;
    }

    @media ($mq-full) {
      min-height: 220px;
    }

    @media ($mq-high) {
      min-height: 240px;
    }

    @media ($mq-higher) {
      min-height: 250px;
    }
  }
}
</style>
